"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _breakpoints = _interopRequireDefault(require("../../utils/breakpoints"));
var _getContrastingTextColor = require("../../utils/getContrastingTextColor");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Dialog = {
  styles: function styles(theme) {
    var lastButtonLabelColor = (0, _getContrastingTextColor.getContrastingTextColorHexString)(theme.colors.primary, undefined, undefined, _getContrastingTextColor.PRIMARY_CONTRAST_STANDARD);
    return {
      title: {
        alignItems: "flex-start",
        color: theme.colors.baseContrast070,
        fontSize: theme.typography.fontSize + 2,
        fontWeight: 600,
        marginBottom: theme.spacing.base / 2
      },
      defaultDialogBoxStyles: {
        border: theme.colors.baseContrast050,
        borderRadius: 8,
        backgroundColor: theme.colors.pageBackground,
        padding: theme.spacing.base * 2,
        fontFamily: theme.typography.fontFamily
      },
      svgIcon: {
        width: 18,
        height: 18,
        minHeight: 18,
        minWidth: 18,
        marginTop: 2
      },
      content: {
        fontSize: theme.typography.fontSize,
        fontFamily: theme.typography.fontFamily
      },
      button: {
        borderColor: theme.colors.baseContrast040,
        "&:hover, &:focus-visible": {
          backgroundColor: theme.colors.baseContrast015
        },
        "& label": {
          color: theme.colors.baseContrast070
        },
        "&:last-child > label": {
          color: lastButtonLabelColor
        },
        "&:last-child": {
          background: theme.colors.primary,
          borderColor: theme.colors.primary,
          "&:hover, &:focus-visible": {
            background: theme.colors.primaryDark,
            borderColor: theme.colors.primaryDark,
            "& label": {
              color: lastButtonLabelColor
            }
          }
        }
      },
      small: {
        "& $actions": {
          width: "100%"
        },
        "& $button": {
          width: "100%"
        }
      },
      actions: _defineProperty({
        flexWrap: "wrap"
      }, _breakpoints.default.ON_MOBILE, {
        flexDirection: "column",
        width: "100%",
        "& button": {
          width: "100%"
        }
      })
    };
  }
};
var _default = exports.default = Dialog;